import React from 'react'
import { gql } from 'apollo-boost'

export interface Channel {
  name: string
  disabled: boolean
  login_required: boolean
  permalink: string
  supported_logins: string[]
  url: string
  menuMarkupHidden?: boolean
  integrations: {
    remote_id: string
    restaurant_id: number
    restaurant_location_id: number
    settings: {
      [key: string]: string | boolean
    }
  }[]
}

export const ChannelCtx = React.createContext<Channel | null>(null)

export const GET_CHANNEL = gql`
  query LoadChannel($channel_id: ID!, $integration_id: ID!, $settingsType: String!) {
    channel(id: $channel_id) {
      name
      disabled
      login_required
      permalink
      supported_logins
      menuMarkupHidden
      url
      integrations(id: $integration_id) {
        restaurant_id
        restaurant_location_id
        remote_id
        settings
      }
      settingsJson(channelType: $settingsType)
    }
  }
`
